// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__vQdqs","error":"Textarea_error__BD2Br","readonly":"Textarea_readonly__kULAA","disabled":"Textarea_disabled__35gAG"};